module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-md"
  }, [_c('div', {
    staticClass: "modal-content modal-edit-bg"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal"
  }, [_c('div', {
    staticClass: "close_btn",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "padding": "20px"
    }
  }, [(_vm.isWufooLoading) ? _c('div', {
    staticClass: "text-center"
  }, [_c('page-loader')], 1) : _vm._e(), _vm._v(" "), (!_vm.isWufooLoading) ? _c('div', [_c('iframe', {
    staticStyle: {
      "min-width": "100%",
      "height": "800px",
      "border": "none"
    },
    attrs: {
      "id": "JotFormIFrame-231234850054145",
      "title": "Suggestion Form",
      "onload": "window.parent.scrollTo(0,20)",
      "allowtransparency": "true",
      "allowfullscreen": "true",
      "src": 'https://form.jotform.com/231234850054145?' +
        _vm.prefillFields,
      "frameborder": "0",
      "scrolling": "yes"
    }
  })]) : _vm._e()])])])])])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a88f1d00", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a88f1d00"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/resourceData/SuggestForm.vue
// module id = 560
// module chunks = 4